import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from "vue";
import PropertyItem from "@/components/PropertyItem.vue";
import { DecoratedAsset } from "@/types";
import { getProperty } from "@/config/asset";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusSection',
  props: {
    device: null
  },
  setup(__props: any) {

const props = __props as {
  device: DecoratedAsset;
}



const { device } = toRefs(props);

const isMobile = computed(() => {
  return getProperty(device.value, "connection_type").value === "Mobile";
});

return { __sfc: true,props, device, isMobile, PropertyItem }
}

})